import { FieldMasterData } from '../../types/FieldMasterData';

export const fieldMasterData: FieldMasterData[] = [
  {
    id: 1,
    fieldTypeId: 1,
    ph_min: 5.5,
    ph_max: 6,
    ec_min: 0,
    ec_max: 0.25,
    p2o5_min: 20,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 4,
    k2o_saturation_min: 2,
    k2o_saturation_max: 4,
    cao_saturation_min: 40,
    cao_saturation_max: 50,
    mgo_saturation_min: 10,
    mgo_saturation_max: 15,
    ratio_mgo_k2o_min: 1.1,
    ratio_mgo_k2o_max: 3.2,
    base_saturation_min: 52,
    base_saturation_max: 69,
    k2o_saturation_max_power: 8,
    sio2_min: 0,
    ratio_cao_mgo_min: 3.7,
    ratio_cao_mgo_max: 7,
  },
  {
    id: 2,
    fieldTypeId: 2,
    ph_min: 6.4,
    ph_max: 6.8,
    ec_min: 0,
    ec_max: 0.25,
    p2o5_min: 20,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 3,
    k2o_saturation_min: 2,
    k2o_saturation_max: 4,
    cao_saturation_min: 50,
    cao_saturation_max: 60,
    mgo_saturation_min: 10,
    mgo_saturation_max: 15,
    ratio_mgo_k2o_min: 1.1,
    ratio_mgo_k2o_max: 3.2,
    base_saturation_min: 52,
    base_saturation_max: 69,
    k2o_saturation_max_power: 4,
    sio2_min: 0,
    ratio_cao_mgo_min: 3.7,
    ratio_cao_mgo_max: 7,
  },
  {
    id: 3,
    fieldTypeId: 3,
    ph_min: 6,
    ph_max: 6.5,
    ec_min: 0,
    ec_max: 0.35,
    p2o5_min: 40,
    p2o5_max: 80,
    nitro_nn_min: 0,
    nitro_nn_max: 6,
    k2o_saturation_min: 3,
    k2o_saturation_max: 6,
    cao_saturation_min: 50,
    cao_saturation_max: 60,
    mgo_saturation_min: 15,
    mgo_saturation_max: 20,
    ratio_mgo_k2o_min: 1.1,
    ratio_mgo_k2o_max: 2.9,
    base_saturation_min: 68,
    base_saturation_max: 86,
    k2o_saturation_max_power: 10,
    sio2_min: 0,
    ratio_cao_mgo_min: 3.5,
    ratio_cao_mgo_max: 5.6,
  },
  {
    id: 4,
    fieldTypeId: 4,
    ph_min: 5.5,
    ph_max: 6,
    ec_min: 0,
    ec_max: 0.15,
    p2o5_min: 20,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 2.5,
    k2o_saturation_min: 2,
    k2o_saturation_max: 5,
    cao_saturation_min: 40,
    cao_saturation_max: 50,
    mgo_saturation_min: 10,
    mgo_saturation_max: 15,
    ratio_mgo_k2o_min: 0.9,
    ratio_mgo_k2o_max: 3.2,
    base_saturation_min: 52,
    base_saturation_max: 70,
    k2o_saturation_max_power: 8,
    sio2_min: 0,
    ratio_cao_mgo_min: 3.7,
    ratio_cao_mgo_max: 7,
  },
  {
    id: 5,
    fieldTypeId: 5,
    ph_min: 6,
    ph_max: 6.5,
    ec_min: 0,
    ec_max: 0.15,
    p2o5_min: 20,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 2.5,
    k2o_saturation_min: 2,
    k2o_saturation_max: 5,
    cao_saturation_min: 50,
    cao_saturation_max: 60,
    mgo_saturation_min: 10,
    mgo_saturation_max: 15,
    ratio_mgo_k2o_min: 0.9,
    ratio_mgo_k2o_max: 3.2,
    base_saturation_min: 62,
    base_saturation_max: 80,
    k2o_saturation_max_power: 8,
    sio2_min: 0,
    ratio_cao_mgo_min: 4.6,
    ratio_cao_mgo_max: 8.4,
  },
  {
    id: 6,
    fieldTypeId: 6,
    ph_min: 4.5,
    ph_max: 5,
    ec_min: 0,
    ec_max: 0.2,
    p2o5_min: 20,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 3,
    k2o_saturation_min: 3,
    k2o_saturation_max: 6,
    cao_saturation_min: 15,
    cao_saturation_max: 25,
    mgo_saturation_min: 3,
    mgo_saturation_max: 7,
    ratio_mgo_k2o_min: 0.2,
    ratio_mgo_k2o_max: 1,
    base_saturation_min: 21,
    base_saturation_max: 38,
    k2o_saturation_max_power: 6,
    sio2_min: 0,
    ratio_cao_mgo_min: 5.6,
    ratio_cao_mgo_max: 13.9,
  },
  {
    id: 7,
    fieldTypeId: 7,
    ph_min: 5.5,
    ph_max: 6,
    ec_min: 0,
    ec_max: 0.15,
    p2o5_min: 25,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 2.5,
    k2o_saturation_min: 2,
    k2o_saturation_max: 5,
    cao_saturation_min: 40,
    cao_saturation_max: 50,
    mgo_saturation_min: 5,
    mgo_saturation_max: 10,
    ratio_mgo_k2o_min: 0.4,
    ratio_mgo_k2o_max: 2.1,
    base_saturation_min: 47,
    base_saturation_max: 65,
    k2o_saturation_max_power: 8,
    sio2_min: 0,
    ratio_cao_mgo_min: 5.6,
    ratio_cao_mgo_max: 13.9,
  },
  {
    id: 8,
    fieldTypeId: 8,
    ph_min: 6,
    ph_max: 6.5,
    ec_min: 0,
    ec_max: 0.2,
    p2o5_min: 10,
    p2o5_max: 20,
    nitro_nn_min: 0,
    nitro_nn_max: 2,
    k2o_saturation_min: 1,
    k2o_saturation_max: 3,
    cao_saturation_min: 50,
    cao_saturation_max: 60,
    mgo_saturation_min: 10,
    mgo_saturation_max: 20,
    ratio_mgo_k2o_min: 1.4,
    ratio_mgo_k2o_max: 8.6,
    base_saturation_min: 61,
    base_saturation_max: 83,
    k2o_saturation_max_power: 5,
    sio2_min: 25,
    ratio_cao_mgo_min: 3.5,
    ratio_cao_mgo_max: 8.4,
  },
  {
    id: 9,
    fieldTypeId: 9,
    ph_min: 6,
    ph_max: 6.5,
    ec_min: 0,
    ec_max: 0.2,
    p2o5_min: 10,
    p2o5_max: 20,
    nitro_nn_min: 0,
    nitro_nn_max: 2,
    k2o_saturation_min: 1,
    k2o_saturation_max: 3,
    cao_saturation_min: 50,
    cao_saturation_max: 60,
    mgo_saturation_min: 10,
    mgo_saturation_max: 20,
    ratio_mgo_k2o_min: 1.4,
    ratio_mgo_k2o_max: 8.6,
    base_saturation_min: 61,
    base_saturation_max: 83,
    k2o_saturation_max_power: 5,
    sio2_min: 15,
    ratio_cao_mgo_min: 3.5,
    ratio_cao_mgo_max: 8.4,
  },
  {
    id: 10,
    fieldTypeId: 10,
    ph_min: 4,
    ph_max: 5,
    ec_min: 0,
    ec_max: 0.25,
    p2o5_min: 20,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 4,
    k2o_saturation_min: 3,
    k2o_saturation_max: 6,
    cao_saturation_min: 15,
    cao_saturation_max: 25,
    mgo_saturation_min: 3,
    mgo_saturation_max: 7,
    ratio_mgo_k2o_min: 0.2,
    ratio_mgo_k2o_max: 1,
    base_saturation_min: 21,
    base_saturation_max: 38,
    k2o_saturation_max_power: 10,
    sio2_min: 0,
    ratio_cao_mgo_min: 3,
    ratio_cao_mgo_max: 11.6,
  },
  {
    id: 11,
    fieldTypeId: 11,
    ph_min: 6,
    ph_max: 6.5,
    ec_min: 0,
    ec_max: 0.15,
    p2o5_min: 10,
    p2o5_max: 30,
    nitro_nn_min: 0,
    nitro_nn_max: 2.5,
    k2o_saturation_min: 1,
    k2o_saturation_max: 3,
    cao_saturation_min: 50,
    cao_saturation_max: 60,
    mgo_saturation_min: 5,
    mgo_saturation_max: 10,
    ratio_mgo_k2o_min: 0.7,
    ratio_mgo_k2o_max: 4.3,
    base_saturation_min: 56,
    base_saturation_max: 73,
    k2o_saturation_max_power: 5,
    sio2_min: 0,
    ratio_cao_mgo_min: 7,
    ratio_cao_mgo_max: 16.7,
  },
  {
    id: 12,
    fieldTypeId: 12,
    ph_min: 5.5,
    ph_max: 6.5,
    ec_min: 0,
    ec_max: 0.15,
    p2o5_min: 10,
    p2o5_max: 50,
    nitro_nn_min: 0,
    nitro_nn_max: 2.5,
    k2o_saturation_min: 2,
    k2o_saturation_max: 5,
    cao_saturation_min: 40,
    cao_saturation_max: 60,
    mgo_saturation_min: 5,
    mgo_saturation_max: 20,
    ratio_mgo_k2o_min: 0.4,
    ratio_mgo_k2o_max: 4.3,
    base_saturation_min: 47,
    base_saturation_max: 85,
    k2o_saturation_max_power: 8,
    sio2_min: 0,
    ratio_cao_mgo_min: 2.8,
    ratio_cao_mgo_max: 16.7,
  },
  {
    id: 13,
    fieldTypeId: 13,
    ph_min: 5.5,
    ph_max: 6,
    ec_min: 0,
    ec_max: 0.15,
    p2o5_min: 10,
    p2o5_max: 20,
    nitro_nn_min: 0,
    nitro_nn_max: 2.5,
    k2o_saturation_min: 1,
    k2o_saturation_max: 3,
    cao_saturation_min: 40,
    cao_saturation_max: 50,
    mgo_saturation_min: 5,
    mgo_saturation_max: 15,
    ratio_mgo_k2o_min: 0.7,
    ratio_mgo_k2o_max: 6.4,
    base_saturation_min: 46,
    base_saturation_max: 68,
    k2o_saturation_max_power: 5,
    sio2_min: 0,
    ratio_cao_mgo_min: 3.7,
    ratio_cao_mgo_max: 13.9,
  },
  {
    id: 14,
    fieldTypeId: 14,
    ph_min: 6,
    ph_max: 6.5,
    ec_min: 0,
    ec_max: 1,
    p2o5_min: 50,
    p2o5_max: 100,
    nitro_nn_min: 0,
    nitro_nn_max: 20,
    k2o_saturation_min: 3,
    k2o_saturation_max: 6,
    cao_saturation_min: 50,
    cao_saturation_max: 60,
    mgo_saturation_min: 10,
    mgo_saturation_max: 15,
    ratio_mgo_k2o_min: 0.7,
    ratio_mgo_k2o_max: 2.1,
    base_saturation_min: 63,
    base_saturation_max: 81,
    k2o_saturation_max_power: 10,
    sio2_min: 0,
    ratio_cao_mgo_min: 4.6,
    ratio_cao_mgo_max: 8.4,
  },
];
